// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3jLNf","inner":"Footer_inner__3-zHx"};